import { render, staticRenderFns } from "./DocumentTabContent.vue?vue&type=template&id=d0286572&scoped=true"
import script from "./DocumentTabContent.vue?vue&type=script&lang=js"
export * from "./DocumentTabContent.vue?vue&type=script&lang=js"
import style0 from "./DocumentTabContent.vue?vue&type=style&index=0&id=d0286572&prod&scoped=true&lang=scss"
import style1 from "./DocumentTabContent.vue?vue&type=style&index=1&id=d0286572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0286572",
  null
  
)

export default component.exports